import { Col, Row } from 'reactstrap';

import TableActions from 'components/layouts/table';
import { useActions } from 'utils/hooks';
import * as routingAreasActions from 'store/routing-areas/actions';
import Table, { useTable } from 'common/components/table';
import Switch from 'common/components/form/inputs/Switch';
import EnumsDropdown from '../Dropdown';

const RoutingAreas = () => {
  const [updateRoutingArea] = useActions([routingAreasActions.updateRoutingArea]);

  const table = useTable({
    label: 'routing_areas',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        width: 4
      },
      {
        header: 'Is Important',
        key: 'is_important',
        type: 'boolean',
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false }
        ],
        width: 2
      },
      {
        header: 'Can Avoid',
        key: 'can_avoid',
        type: 'boolean',
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false }
        ],
        width: 2
      }
    ]
  });

  return (
    <Row className="routing-areas-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Routing Areas"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[{ type: 'search' }]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          rows={{
            is_important: data => (
              <Switch
                className="ms-3 mb-0"
                value={data.is_important}
                onChange={() =>
                  updateRoutingArea({
                    ...data,
                    is_important: !data.is_important,
                    table: 'routing_areas'
                  })
                }
                size="sm"
              />
            ),
            can_avoid: data => (
              <Switch
                className="ms-3 mb-0"
                value={data.can_avoid}
                onChange={() =>
                  updateRoutingArea({ ...data, can_avoid: !data.can_avoid, table: 'routing_areas' })
                }
                size="sm"
              />
            )
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default RoutingAreas;
